import { GCRoleType } from './GCRoleType';

export const GCRoleTypeOptions = [
    {
        id: GCRoleType.GeneralContractor,
        name: 'General Contractor',
        shortName: 'GC',
    },
    {
        id: GCRoleType.Employee,
        name: 'Employee',
        shortName: 'Employee',
    },
    {
        id: GCRoleType.Owner,
        name: 'Owner',
        shortName: 'Owner',
    },
];
